const SET_LOGO = "SET_LOGO";
const SET_LOGO_SUCCESS = "SET_LOGO_SUCCESS";
const SET_LOGO_FAIL = "SET_LOGO_FAIL";

export {
    SET_LOGO,
    SET_LOGO_SUCCESS,
    SET_LOGO_FAIL
};